import { render, staticRenderFns } from "./HostingHistory.vue?vue&type=template&id=5dad9436&scoped=true&"
import script from "./HostingHistory.vue?vue&type=script&lang=js&"
export * from "./HostingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad9436",
  null
  
)

export default component.exports